var React = require('react');

function BackArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"small-left"),React.createElement("g",{"id":"LP","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"Extra-large:-Desktops---12-col-sticky-static-page-changelog","transform":"translate(-1216.000000, -31.000000)","stroke":"#2B2B2E"},React.createElement("g",{"id":"small-left","transform":"translate(1217.000000, 31.000000)"},React.createElement("polyline",{"id":"Path","points":"4.5 0.5 0 5 4.5 9.5"}))))]);
}

BackArrowInline.defaultProps = {"width":"6px","height":"10px","viewBox":"0 0 6 10","version":"1.1"};

module.exports = BackArrowInline;

BackArrowInline.default = BackArrowInline;
